import styled from "styled-components";

const CovidQuery = () => {
  return (
    <Card>
      <VerticalLine />
      <div style={{ padding: "2% 4%" }}>
        <h2 style={{ fontWeight: 600 }}>
          For COVID-19 Vaccination related queries
        </h2>
        <ButtonContainer >
          <div
           
            style={{
              display: "flex",
              flexGrow: 1,
              justifyContent: "center",
              marginTop: "0 !important"
            }}
          >
            <img
              src="/img/success-black-check-mark.svg"
              alt=""
              style={{ marginRight: "5%" }}
            />
           <a    target="_blank" href="https://www.cdc.gov/coronavirus/2019-ncov/faq.html"> <span>FAQs & Articles</span></a>
          </div>
          <div
          
            style={{
              display: "flex",
              flexGrow: 1,
              justifyContent: "center",
              marginTop: "0 !important"
            }}
          >
            <img
              src="/img/success-black-check-mark.svg"
              alt=""
              style={{ marginRight: "5%" }}
            />
           <a    target="_blank" href="https://www.mohfw.gov.in/covid_vaccination/vaccination/faqs.html">  <span>Vaccination Queries</span></a>
          </div>
          <div
            
            style={{
              display: "flex",
              flexGrow: 1,
              justifyContent: "center",
              marginTop: "0 !important"
            }}
          >
            <img
              src="/img/success-black-check-mark.svg"
              alt=""
              style={{ marginRight: "5%" }}
            />
           <span>Chat with us</span>
          </div>
          <div
           
            style={{
              display: "flex",
              flexGrow: 1,
              justifyContent: "center",
              marginTop: "0 !important"
            }}
          >
            <img
              src="/img/success-black-check-mark.svg"
              alt=""
              style={{ marginRight: "5%" }}
            />
            <a   target="_blank" href="https://www.cowin.gov.in"> <span>Registration</span></a>
          </div>
        </ButtonContainer>
      </div>
    </Card>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  
  justify-content: space-around;
  & > div {
    margin-inline: 1%;
    padding-block: 1%;
    border: 2px solid #01d6c0;
  border-radius: 50px;
  font-weight: 600;
  background-color: #c5f0eb;
  padding: 1% 3%;

  &:hover {
    background-color: #01d6c0;
  }
  }
`;

const VerticalLine = styled.div`
  position: absolute;
  background-color: #00b5a2;
  height: inherit;
  width: 2%;
  display: block;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
`;

const Card = styled.div`
  height: 12rem;
  background-color: white;
  margin-block: 2%;
  border-radius: 20px;
  box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -webkit-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -moz-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
`;

export default CovidQuery;
